import { mainRouteInitial } from "../../Data/Constant";
import { useNavigate, useLocation } from "react-router-dom";
import { departmentSidebarData } from "../../Data";
// import { X } from 'lucide-react';  // ← if you use lucide-react icons
// or use material symbols: close

const MainSitebar = ({ mobileMode = false, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const basePath = `/${mainRouteInitial}`;

  const isActive = (item) => {
    const fullPath = item?.path ? `${basePath}/${item?.path}` : basePath;
    return (
      location?.pathname?.split("/")?.[2]?.toLowerCase() === item?.path?.toLowerCase() ||
      location?.pathname?.startsWith(fullPath + "/") ||
      item?.activeOn?.some((ele) => ele?.toLowerCase() == location?.pathname?.split("/")?.[2]?.toLowerCase())
    );
  };

  const handleNavigate = (path) => {
    navigate(`${basePath}/${path}`);
    if (mobileMode) {
      onClose?.(); // close drawer on mobile after navigation
    }
  };

  return (
    <div className="flex h-full flex-col">
      {/* Header / Brand + Close button on mobile */}
      <div className="flex items-center justify-between p-4 border-b border-slate-200 dark:border-slate-800">
        <div className="flex gap-3 items-center">
          <div
            className="bg-center bg-no-repeat aspect-square bg-cover rounded-full size-10 shrink-0 shadow-sm"
            style={{
              backgroundImage: `url(${require("../../Assets/SuratCityPoliceLogo.jpg")})`,
            }}
          />
          <div className="flex flex-col overflow-hidden">
            <h1 className="text-slate-900 dark:text-white font-bold truncate text-[20px]">Night Eye</h1>
            <p className="text-slate-500 dark:text-slate-400 text-xs truncate">{/* Portal */}</p>
          </div>
        </div>

        {mobileMode && (
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800" aria-label="Close menu">
            <span className="material-symbols-outlined text-2xl">close</span>
            {/* or: <X size={24} /> */}
          </button>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto p-4 space-y-1.5">
        {departmentSidebarData
          .filter((ele) => !ele?.hide)
          .map((item) => {
            const active = isActive(item);

            return (
              <button
                key={item.label}
                onClick={() => handleNavigate(item.path ?? "")}
                className={`
                w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors text-sm
                ${active ? "bg-primary/10 text-primary dark:bg-primary/20 font-semibold" : "text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800"}
              `}
              >
                <span className="material-symbols-outlined text-[24px]">{item.icon}</span>
                <span>{item.label}</span>
              </button>
            );
          })}
      </nav>
    </div>
  );
};

export default MainSitebar;
